<template>
    <nav class="panel">
        <div class="panel-block">
            <p class="control has-icons-left">
                <input class="input is-small" type="text" placeholder="Search" v-model="search" />
                <span class="icon is-left">
                    <i class="fas fa-search" aria-hidden="true"></i>
                </span>
            </p>
        </div>
        <p class="panel-tabs">
            <a
                :class="selectedList === values.SELECTED ? ' is-active ' : ''"
                @click="selectList(values.SELECTED)"
            >
                Selected
            </a>
            <a
                :class="selectedList === values.ALL_COUNTRIES ? ' is-active ' : ''"
                @click="selectList(values.ALL_COUNTRIES)"
            >
                All
            </a>
            <a
                v-for="country in countries"
                :key="country.id"
                :class="selectedList === country.id ? ' is-active ' : ''"
                @click="selectList(country.id)"
            >
                {{ country.label }}
            </a>
        </p>
        <div class="panel-block">
            <button
                v-if="selectedList !== values.SELECTED"
                @click="selectAll()"
                class="button is-link is-outlined is-fullwidth is-small"
            >
                Select All
            </button>
            <div id="select-divider"></div>
            <button @click="clear()" class="button is-link is-outlined is-fullwidth is-small">
                Clear
            </button>
        </div>
        <div id="terminals-list">
            <label v-for="terminal in terminalsToList" :key="terminal.id" class="panel-block">
                <input
                    type="checkbox"
                    :checked="isTerminalSelected(terminal.id)"
                    @change="toggle(terminal, $event)"
                />
                {{ terminal.label }}
            </label>
        </div>
    </nav>
</template>
<script>
import fuzzysort from 'fuzzysort'

const values = {
    ALL_COUNTRIES: 'ALL_COUNTRIES',
    SELECTED: 'SELECTED',
}

export default {
    name: 'TerminalSelector',
    props: {
        terminals: Array,
        countries: Array,
        setSelectedTerminals: Function,
        selectedTerminals: Array,
    },
    data: () => ({
        selectedList: values.ALL_COUNTRIES,
        search: '',
        values,
    }),
    computed: {
        terminalsToList() {
            const { selectedList, search } = this.$data
            const { terminals, selectedTerminals } = this.$props
            const filterByName = (list) => {
                if (!search) {
                    return list
                }
                return fuzzysort.go(search, list, { key: 'label' }).map((result) => result.obj)
            }
            const filterByList = () => {
                if (selectedList === values.SELECTED) {
                    return selectedTerminals
                }
                if (selectedList === values.ALL_COUNTRIES) {
                    return terminals
                }
                return terminals.filter((terminal) => terminal.city.countryCode === selectedList)
            }
            return filterByName(filterByList()).sort((a, b) => a.label.localeCompare(b.label))
        },
    },
    methods: {
        selectList(countryCode) {
            this.selectedList = countryCode
        },
        isTerminalSelected(terminalId) {
            const containsTerminal = (terminal) => terminal.id === terminalId
            return this.selectedTerminals.some(containsTerminal)
        },
        selectAll() {
            if (this.selectedList === values.ALL_COUNTRIES) {
                this.setSelectedTerminals(this.terminals)
            } else if (this.selectedList !== values.SELECTED) {
                const isTerminalAlreadySelected = (terminal) =>
                    this.selectedTerminals.some((selected) => selected.id === terminal.id)
                const terminalsInCountryOrAlreadySelected = (terminal) =>
                    terminal.city.countryCode === this.selectedList
                        ? true
                        : isTerminalAlreadySelected(terminal)
                this.setSelectedTerminals(
                    this.terminals.filter(terminalsInCountryOrAlreadySelected),
                )
            }
        },
        clear() {
            const clearAllTerminals =
                this.selectedList === values.ALL_COUNTRIES || this.selectedList === values.SELECTED
            if (clearAllTerminals) {
                this.setSelectedTerminals([])
            } else {
                const isTerminalAlreadySelected = (terminal) =>
                    this.selectedTerminals.some((selected) => selected.id === terminal.id)
                const terminalsNotInCountryOrAlreadySelected = (terminal) =>
                    terminal.city.countryCode !== this.selectedList &&
                    isTerminalAlreadySelected(terminal)
                this.setSelectedTerminals(
                    this.terminals.filter(terminalsNotInCountryOrAlreadySelected),
                )
            }
        },
        toggle(terminal, event) {
            if (event.target.checked) {
                const isTerminalSelected = (selectedTerminal) => selectedTerminal.id === terminal.id
                const notAdded = !this.selectedTerminals.some(isTerminalSelected)
                if (notAdded) {
                    this.setSelectedTerminals([...this.selectedTerminals, terminal])
                }
            } else {
                this.setSelectedTerminals(
                    this.selectedTerminals.filter(
                        (selectedTerminal) => selectedTerminal.id !== terminal.id,
                    ),
                )
            }
        },
    },
}
</script>
<style lang="scss" scoped>
#terminals-list {
    max-height: 70vh;
    overflow-y: scroll;
}

#select-divider {
    margin-left: 3px;
    margin-right: 3px;
}
</style>
